import { system } from '../../../system'

export const AbsoluteFill = system('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
})
